
import { MdAdd } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import zigzag from "../../../resources/img/zigzag.png";
import boule from "../../../resources/img/boule.png";
import { Formik, Form, FormikHelpers } from "formik";
import { LoadingButton } from "@mui/lab";
import FormFieldInput from "../../../components/Forms/FormFieldInput";
import { useEffect, useState } from "react";
import { useAxe } from "../../axes";
import { getAllAxes, truncateText } from "../../../utils/monthDiff";
import { selectAuthentificated } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import FormFieldTextArea from "../../../components/Forms/FormFieldTextArea";
import { emailValidationSchema } from "../validation";
import { clients } from "../../../lib/axios";
import { Notifications } from "../../../components/notifications";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


interface MessageDto {
  fullname? : string;
  email?: string;
  message?: string;
}


const Home = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("common");
  const isAuthentificated = useSelector(selectAuthentificated); 

 

  const { data: axeResponse, isLoading, isError, isSuccess } = useAxe({
    // sortOrder: sorting ,
    // pageSize: defaultPageSize?? pageSize,
    // pageNumber: pageNumber,
    // filters: queryFilter,
    // hasArtificialDelay: true,
  });

  const axes = axeResponse?.data;
  const pagination = axeResponse?.pagination;

  // const axes = getAllAxes();


  const [message, setMessage] = useState({
    fullname: "",
    email: "",
    message: "",
  } as MessageDto);

  const submitMessage = async (data: MessageDto, formikHelpers: FormikHelpers<MessageDto>) => {
    console.log("MESSAGE ", data);
    let formatedMessage = `${data.fullname}/${data.email} vous envoi le message suivant: ${data.message}`;
    let newMessage = {
      message: formatedMessage
    } as any;
   
    const axios = await clients();
    axios.post(`/api/Utils/ContactUs`, newMessage)
    .then((response) => {
        // go to the preview page
        formikHelpers.resetForm();
        formikHelpers.setSubmitting(false);
        Notifications.success("Votre message a été envoyé avec succès ");
    }).catch((e) => {
        formikHelpers.setSubmitting(false);
        console.error(e);
        Notifications.error("Une erreur est survenue lors de l'envoi de votre message");
    });
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <main>
        <section id="card-content">
            <div className="row h-370 pt-50" style={{ backgroundColor: "white" }}>
              <div className="col-md-6">
                <div className="text-header">
                    <h1 className="color-primary" >{ t('app.homeTitle') }</h1>
                    <p dangerouslySetInnerHTML={{ __html: t('app.homeDescription') }}></p>
                </div>
              </div>
              <div className="col-md-6">
                    <img className="img-position" src={boule} alt="header image" />
              </div>
            </div>
            <br/>
            <div className="mt-2">
                <div className="row">
                  {
                     (axes && axes.length > 0)
                      ?
                      axes.map((axe, index) => (
                        <div key={index} className="card card-width text-center mmb-7 ml-auto mr-auto">
                          <div className="card-body pl-6 pr-6">
                            <h3 className="card-title color-primary">{ axe.label }</h3>
                            <p className="card-text">
                                { axe.description }
                            </p>
                            <NavLink 
                              className={"btn btn-primary br-5"}
                              to={`/new/projects/${axe.id}`}
                            >
                              { t('app.introduct') } 
                            </NavLink>
                          </div>
                        </div>
                      ))
                      :
                      <>
                          <span className="text-center mt-3 mb-3" style={{ marginLeft: "auto", marginRight: "auto" }}>{ t('app.noneResult') } .</span>
                      </> 
                  }
                  {/* <Slider 
                   dots={true}
                   centerMode={true}
                   // centerPadding={'10px'}
                   infinite={true}
                   speed={500}
                   autoplay={true}
                   slidesToShow={1}
                   slidesToScroll={1}
                   className=""
                  >
                    {
                      axes?.map((axe, index) => (
                          <div key={index} className="card card-width text-center slick-block">
                            <div className="card-body">
                              <h3 className="card-title color-primary">{ axe.label }</h3>
                              <p className="card-text" title={axe.description}>
                                  { truncateText(axe.description, 220) }
                              </p>
                              <NavLink 
                                className={"btn btn-primary br-5"}
                                to={`/new/projects/${axe.id}`}
                              >
                                { t('app.introduct') } 
                              </NavLink>
                            </div>
                          </div>
                      ))
                    }
                  </Slider> */}
                </div>
                <br/>
                <br/>
                <div className="row">
                    <div className="card card-2 mmb-7 ml-auto mr-auto">
                      <div className="card-body p-6">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mail-info">
                                <h1>{ t('app.mailInfos.title') }</h1>
                                <p>{ t('app.mailInfos.subTitle') }</p>

                                <div className="mt-4">
                                  <span ><i className="myprojecticon-device_fixed-line_phone"></i> +237 698754589</span><br/>
                                  <span ><i className="myprojecticon-email"></i> fondationorange.cameroun@orange.com</span>
                                </div>
                                <div className="mt-4">
                                  <h6>{ t('app.mailInfos.connectWithUs') }</h6>
                                  <div className="d-inline">
                                    <a className="btn btn-social btn-instagram" href="#"><span className="sr-only">Instagram</span></a>
                                    <a className="btn btn-social btn-linkedin" href="#"><span className="sr-only">Linkedin</span></a>
                                    <a className="btn btn-social btn-youtube" href="#"><span className="sr-only">YouTube</span></a>
                                  </div>
                                </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="">
                                <Formik
                                  initialValues={message}
                                  validationSchema={emailValidationSchema}
                                  onSubmit={(values,formikHelpers) => submitMessage(values, formikHelpers) } 
                                  // validateOnChange={false}
                                  validateOnMount={false}
                                  // initialStatus={true}
                                  enableReinitialize={false} // Réinitialise les valeurs et désactive la validation lors du premier rendu
                                >
                                
                                  {({ errors, isSubmitting, values, setFieldValue, handleReset }) => {
                                    return (
                                      <Form>
                                          <div className="row">
                                              <div className="col-md-6">
                                                <FormFieldInput name="fullname" setFieldValue={setFieldValue} label={ t('app.mailInfos.fullname') } required/>
                                              </div>
                                              <div className="col-md-6">
                                                <FormFieldInput name="email" type="email" setFieldValue={setFieldValue} label={ t('app.mailInfos.email') } required/>
                                              </div>
                                          </div>
                                          <div className="row">
                                              <div className="col-md-12">
                                                <FormFieldTextArea name="message" label={ t('app.mailInfos.message') } required/>
                                              </div>
                                          </div>
                                          <br/>
                                          <div>
                                              <LoadingButton 
                                                  type='submit' 
                                                  variant="contained"
                                                  className="px-1"
                                                  children={ t('app.send') }
                                                  loading={isSubmitting}
                                                  style={{
                                                    marginLeft:"10px",
                                                    color: "#fff",
                                                    backgroundColor: "#FF7900",
                                                    width: "100px !important"
                                                  }}
                                                  sx={{
                                                    "&.MuiButton-root": {
                                                      textTransform: 'none',
                                                      height: "32px",
                                                      width: "100px",
                                                    },
                                                    "&.Mui-disabled": {
                                                      color: "white",
                                                    }
                                                  }}
                                                />
                                          </div> 
                                      </Form>
                                    );
                                  }}
                              </Formik>
                              
                            </div>
                          </div>
                        </div>
                    </div>

                    
                    </div>
                </div>
                

            </div>
            
            
        </section>
    </main>
  );
}
export default Home;

